import {
  boolean,
  index,
  integer,
  jsonb,
  numeric,
  pgEnum,
  pgTable,
  serial,
  text,
  timestamp,
} from "drizzle-orm/pg-core";

import { users } from "./auth";
import { invoices } from "./payments";
import { timestamps } from "./shared";

export const paymentIntentStatusEnum = pgEnum("payment_intent_status", [
  "pending",
  "authorized",
  "fulfilling",
  "completed",
  "failed",
  "expired",
]);

export const paymentIntents = pgTable(
  "payment_intents",
  {
    id: serial().primaryKey(),
    userId: text()
      .notNull()
      .references(() => users.id),
    status: paymentIntentStatusEnum().notNull().default("pending"),
    cartData: jsonb().notNull(),
    billingData: jsonb().notNull(),
    emailOptIn: boolean(),
    amount: numeric({ precision: 10, scale: 2, mode: "number" }).notNull(),
    authTransactionKey: text(),
    invoiceId: integer().references(() => invoices.id),
    errorMessage: text(),
    attempts: integer().notNull().default(0),
    expiresAt: timestamp().notNull(),
    ...timestamps,
  },
  (table) => [
    index("payment_intents_user_id_idx").on(table.userId),
    index("payment_intents_status_idx").on(table.status),
    index("payment_intents_status_expires_at_idx").on(
      table.status,
      table.expiresAt,
    ),
    index("payment_intents_invoice_id_idx").on(table.invoiceId),
  ],
);
